import { render, staticRenderFns } from "./Mediaanalytic.vue?vue&type=template&id=4484534e&scoped=true"
import script from "./Mediaanalytic.vue?vue&type=script&lang=js"
export * from "./Mediaanalytic.vue?vue&type=script&lang=js"
import style0 from "./Mediaanalytic.vue?vue&type=style&index=0&id=4484534e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4484534e",
  null
  
)

export default component.exports